import type {
  AdsAccountBalanceDodFollowHistoryItem,
  AdsAccountBalanceDodListResponse,
  AdsAccountBalanceDodQueryParams,
  AdsAccountBalanceDodSummary,
  BatchFollowAdsAccountBalanceDodParams,
  FollowAdsAccountBalanceDodParams,
} from './type/ads-account-balance-dod'

import { defineApi } from '#/api/define-api'
import { requestClient } from '#/api/request'

export const adsAccountBalanceDodApi = defineApi(
  'operation/adsAccountBalanceDod',
  ({ prefix }) => {
    /**
     * 查询账户余额日环比异常列表。
     * POST /adsAccountBalanceDod/queryRecordPage
     */
    function queryRecordPage(params: AdsAccountBalanceDodQueryParams) {
      return requestClient
        .post<AdsAccountBalanceDodListResponse>(prefix('queryRecordPage'), {
          condition: {
            accountId: params.condition?.accountId,
            amOpenIds: params.condition?.amOpenIds,
            bdOpenIds: params.condition?.bdOpenIds,
            checkDate: params.condition?.checkDate,
            customerId: params.condition?.customerId,
            customerName: params.condition?.customerName,
            dateRange: params.condition?.dateRange,
            followStatus: params.condition?.followStatus,
            isBindCard: params.condition?.isBindCard,
            mediaPlatform: params.condition?.mediaPlatform,
          },
          orderBy: params.orderBy,
          pageIndex: params.pageIndex,
          pageSize: params.pageSize,
          sortBy: params.sortBy,
        })
        .then((res) => ({
          items: res.list.map((item) => ({
            accountId: item.accountId,
            accountName: item.accountName,
            accountType: item.accountType,
            amOpenId: item.amOpenId,
            bdOpenId: item.bdOpenId,
            checkDate: item.checkDate,
            clearAmount: item.clearAmount,
            currency: item.currency,
            customerId: item.customerId,
            customerName: item.customerName,
            dayEndBalance: item.dayEndBalance,
            diffAmount: item.diffAmount,
            diffPct: item.diffPct,
            expectedBalance: item.expectedBalance,
            followOperatedAt: item.followOperatedAt,
            followOperator: item.followOperator,
            followRemark: item.followRemark,
            followStatus: item.followStatus,
            id: item.id,
            isBindCard: item.isBindCard,
            mediaPlatform: item.mediaPlatform,
            prevEndBalance: item.prevEndBalance,
            rechargeAmount: item.rechargeAmount,
            reduceAmount: item.reduceAmount,
            snapshotDiffAmount: item.snapshotDiffAmount,
            snapshotDiffPct: item.snapshotDiffPct,
            spendAmount: item.spendAmount,
          })),
          total: res.total,
        }))
    }

    /**
     * 查询账户余额日环比顶部统计卡片。
     * POST /adsAccountBalanceDod/querySummaryCards
     */
    function querySummaryCards() {
      return requestClient
        .post<AdsAccountBalanceDodSummary>(prefix('querySummaryCards'))
        .then((res) => ({
          pendingFollowCount: res.pendingFollowCount,
          recent3dNewCount: res.recent3dNewCount,
          totalAnomalyCount: res.totalAnomalyCount,
        }))
    }

    /**
     * 单条跟进账户余额日环比异常。
     * POST /adsAccountBalanceDod/follow
     */
    function follow(params: FollowAdsAccountBalanceDodParams) {
      return requestClient.post(prefix('follow'), {
        followRemark: params.followRemark,
        followStatus: params.followStatus,
        recordId: params.recordId,
      })
    }

    /**
     * 批量跟进账户余额日环比异常。
     * POST /adsAccountBalanceDod/batchFollow
     */
    function batchFollow(params: BatchFollowAdsAccountBalanceDodParams) {
      return requestClient.post(prefix('batchFollow'), {
        followRemark: params.followRemark,
        followStatus: params.followStatus,
        recordIds: params.recordIds,
      })
    }

    /**
     * 查询账户余额日环比跟进历史。
     * POST /adsAccountBalanceDod/queryFollowHistory
     */
    function queryFollowHistory(recordId: number) {
      return requestClient
        .post<{
          list: AdsAccountBalanceDodFollowHistoryItem[]
        }>(prefix('queryFollowHistory'), { condition: { recordId } })
        .then((res) =>
          res.list.map((item) => ({
            followStatus: item.followStatus,
            id: item.id,
            operatedAt: item.operatedAt,
            operator: item.operator,
            recordId: item.recordId,
            remark: item.remark,
            source: item.source,
          })),
        )
    }

    return {
      batchFollow,
      follow,
      queryFollowHistory,
      queryRecordPage,
      querySummaryCards,
    }
  },
)
